const steps = [
  {
    number: '01',
    icon: 'ri-search-2-line',
    badge: 'Исследование',
    title: 'Анализ спроса и конкурентов',
    text: 'Находим высокочастотные запросы вашей ниши. Смотрим ТОП-10 выдачи и проектируем материал, который будет полезнее и полнее, чем у конкурентов.',
    color: 'bg-[#1A2B4C]',
  },
  {
    number: '02',
    icon: 'ri-layout-2-line',
    badge: 'AI-SEO структура',
    title: 'Проектирование структуры',
    text: 'Создаем логический скелет статьи с правильной иерархией заголовков (H1, H2, H3), списками и таблицами для лучшего восприятия.',
    color: 'bg-[#253D6B]',
  },
  {
    number: '03',
    icon: 'ri-quill-pen-line',
    badge: 'Копирайтинг',
    title: 'Написание «живого» контента',
    text: 'Используем мощь ИИ для скорости, но каждое слово проходит «очеловечивание» экспертом. Никакой «роботизированности» и спама — плотность ключей строго &lt; 9%.',
    color: 'bg-[#1A2B4C]',
  },
  {
    number: '04',
    icon: 'ri-code-s-slash-line',
    badge: 'SEO-упаковка',
    title: 'Техническая SEO-упаковка',
    text: 'Прописываем мета-теги (Title, Description) и атрибуты Alt для изображений, чтобы поисковые роботы сразу полюбили ваш контент.',
    color: 'bg-[#253D6B]',
  },
  {
    number: '05',
    icon: 'ri-links-line',
    badge: 'Конверсия',
    title: 'Внутренняя перелинковка',
    text: 'Вставляем ссылки на ваши товары и услуги прямо в текст статьи, превращая читателя в покупателя.',
    color: 'bg-[#1A2B4C]',
  },
];

export default function SEOArticleProcess() {
  return (
    <section id="seo-process" className="py-12 sm:py-24 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-list-ordered text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Этапы работы
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Как мы создаём статьи
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-5 rounded-full"></div>
          <p className="text-sm sm:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed font-['Montserrat']">
            Техническая часть понятным языком.
          </p>
        </div>

        <div className="space-y-3 sm:space-y-5">
          {steps.map((step) => (
            <div key={step.number} className={`${step.color} rounded-2xl sm:rounded-3xl overflow-hidden`}>
              <div className="p-4 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
                {/* Number + Icon + Mobile title */}
                <div className="flex items-center gap-3 flex-shrink-0">
                  <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-xl bg-[#C5A880]/20 border border-[#C5A880]/30 flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-lg sm:text-2xl text-[#C5A880]`}></i>
                  </div>
                  <div className="sm:hidden flex-1">
                    <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] uppercase tracking-wider block">
                      Шаг {step.number} — {step.badge}
                    </span>
                    <h3 className="text-sm font-bold text-white font-['Playfair_Display'] mt-0.5 leading-snug">
                      {step.title}
                    </h3>
                  </div>
                </div>

                {/* Desktop label */}
                <div className="hidden sm:block flex-shrink-0 w-52">
                  <span className="inline-block px-3 py-1 rounded-full bg-[#C5A880]/20 border border-[#C5A880]/30 text-[#C5A880] text-xs font-semibold font-['Montserrat'] mb-2">
                    Шаг {step.number} — {step.badge}
                  </span>
                  <h3 className="text-base font-bold text-white font-['Playfair_Display'] leading-snug">
                    {step.title}
                  </h3>
                </div>

                {/* Divider */}
                <div className="hidden sm:block w-px h-12 bg-white/15 flex-shrink-0"></div>

                {/* Text */}
                <p
                  className="text-white/75 text-xs sm:text-sm leading-relaxed font-['Montserrat'] flex-1 text-justify"
                  dangerouslySetInnerHTML={{ __html: step.text }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
